import React, { useContext } from 'react'
import styled from 'styled-components'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import TextButton from 'LuxKit/Button/TextButton'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import config from 'constants/config'
import ContactContext from 'contexts/contactContext'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import ModalContext from 'contexts/ModalContext'
import RequestAgentCallbackModal from 'supportAssistant/components/RequestAgentCallback/Modals/RequestAgentCallbackModal'
import useResponsiveSelector from 'hooks/useResponsiveSelector'
import LineIncomingCallIcon from 'LuxKit/Icons/line/LineIncomingCallIcon'

const SupportButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${rem(20)};

  > * + * {
    margin-left: ${rem(8)};
  }
`

const HelpDescription = styled(BodyText)`
  margin-top: ${rem(8)};
`

interface Props {
  contactNumber?: App.GeoContact
  allowsAgentCallbackRequest?: boolean
}

const ctaText = {
  mobile: 'Call now',
  tablet: 'Call now',
}

function HelpSection({ contactNumber, allowsAgentCallbackRequest }: Props) {
  const currentContact = useContext(ContactContext)
  const contact = contactNumber ?? currentContact.defaultContact

  const ctaValue = useResponsiveSelector(ctaText) ?? contact.humanReadable

  const callbacksFeatureEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.toursRequestAgentCallbackEnabled)

  const showModal = useContext(ModalContext)

  const handleCallbackClick = () => { showModal(<RequestAgentCallbackModal type="TOURS" />) }

  return <>
    <Heading variant="heading6">
      Need help with your booking?
    </Heading>
    <HelpDescription variant="medium">
      Speak to a {config.title} Expert anytime,
      24 hours, 7 days a week
    </HelpDescription>
    <SupportButtons>
      <TextButton kind="secondary" variant="dark" startIcon={<LinePhoneIcon />} href={`tel:${contact.number}`}>
        {ctaValue}
      </TextButton>
      {callbacksFeatureEnabled && allowsAgentCallbackRequest && <TextButton
        kind="secondary"
        variant="dark"
        onClick={handleCallbackClick}
        startIcon={<LineIncomingCallIcon />}
      >
        Request a callback
      </TextButton>}
    </SupportButtons>
  </>
}

export default HelpSection
